import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { Button, Dialog } from '@material-ui/core';
import isEqual from 'lodash/isEqual';
import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ImageCropper } from 'components/common/ImageCropper';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { useSaveImageFromCrop } from 'libs/common/hooks';
import { ButtonContainer, CloseButton, CropperContainer, Title } from './ImageCropperDialog.style';
import { calculateCrop, validateCropAgainstConstraints } from './utils';
var defaultCrop = {
  unit: 'px',
  width: 0,
  height: 0,
  x: 0,
  y: 0
};

var ImageCropperDialog = function ImageCropperDialog(_ref) {
  var imgUrl = _ref.imgUrl,
      open = _ref.open,
      imageRatio = _ref.imageRatio,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm,
      originalCrop = _ref.originalCrop,
      originalImageAnchor = _ref.originalImageAnchor,
      displayAnchor = _ref.displayAnchor,
      constraints = _ref.constraints;

  var _useState = useState(defaultCrop),
      crop = _useState[0],
      setCrop = _useState[1];

  var _useState2 = useState(defaultCrop),
      resetCrop = _useState2[0],
      setResetCrop = _useState2[1];

  var _useState3 = useState(originalImageAnchor),
      imageAnchor = _useState3[0],
      setImageAnchor = _useState3[1];

  var _useState4 = useState({
    ratioX: 1,
    ratioY: 1
  }),
      displayedRatio = _useState4[0],
      setDisplayedRatio = _useState4[1];

  var imageRef = useRef(undefined);

  var _useSaveImageFromCrop = useSaveImageFromCrop(),
      saveImageFromCrop = _useSaveImageFromCrop.saveImageFromCrop;

  var handleImageLoaded = function handleImageLoaded(image) {
    if (image.naturalWidth !== 0 && image.naturalHeight !== 0) {
      var ratioX = image.naturalWidth / image.width;
      var ratioY = image.naturalHeight / image.height;
      setDisplayedRatio({
        ratioX: ratioX,
        ratioY: ratioY
      });
    }

    var initialCrop = calculateCrop({
      image: image,
      originalCrop: originalCrop,
      imageRatio: imageRatio
    });
    setCrop(initialCrop);
    setResetCrop(initialCrop);
    setImageAnchor(originalImageAnchor); // Allow to use toBlob() on the crop canvas

    image.crossOrigin = 'Anonymous';
    imageRef.current = image; // https://www.npmjs.com/package/react-image-crop#:~:text=onImageLoaded(image)%20(optional)

    return false;
  };

  var handleConfirm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _url, savedCrop;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!imageRef.current) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return saveImageFromCrop(imageRef.current, crop);

            case 3:
              _url = _context.sent;
              savedCrop = {
                width: Math.round(crop.width * displayedRatio.ratioX),
                height: Math.round(crop.height * displayedRatio.ratioY),
                x: Math.round(crop.x * displayedRatio.ratioX),
                y: Math.round(crop.y * displayedRatio.ratioY)
              };

              if (_url !== null) {
                onConfirm(_url, imageRef.current.src, savedCrop, imageAnchor);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleConfirm() {
      return _ref2.apply(this, arguments);
    };
  }();

  return __jsx(Dialog, {
    open: open,
    onClose: onClose
  }, __jsx(CloseButton, {
    onClick: onClose
  }), __jsx(FormattedMessage, {
    id: "image-cropper-modal.title",
    tagName: Title
  }), __jsx(CropperContainer, null, __jsx(ImageCropper, {
    imgUrl: imgUrl,
    crop: crop,
    handleCrop: function handleCrop(newCrop) {
      if (validateCropAgainstConstraints({
        crop: newCrop,
        constraints: constraints,
        displayedRatio: displayedRatio
      })) {
        setCrop(newCrop);
      }
    },
    handleImageLoaded: handleImageLoaded,
    setImageAnchor: setImageAnchor,
    imageAnchor: imageAnchor,
    displayedRatio: displayedRatio,
    displayAnchor: displayAnchor
  })), __jsx(ButtonContainer, null, __jsx(Button, {
    variant: "outlined",
    color: "primary",
    disabled: isEqual(resetCrop, crop),
    onClick: function onClick() {
      return setCrop(resetCrop);
    }
  }, __jsx(FormattedMessage, {
    id: "image-cropper-modal.reset"
  })), __jsx(GradientButton, {
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "image-cropper-modal.confirm"
  }))));
};

export default ImageCropperDialog;